import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbdf76da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper",
  id: "refWrap"
}
const _hoisted_2 = {
  key: 1,
  class: "controls"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pdfLoading)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_vue_pdf_embed, {
      ref: "pdfRef",
      source: _ctx.videoUrl,
      page: _ctx.page,
      width: _ctx.width,
      scale: 300,
      onRendered: _ctx.handleDocumentRender
    }, null, 8, ["source", "page", "width", "onRendered"]),
    (!_ctx.pdfLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            disabled: _ctx.page <= 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.page--))
          }, "-", 8, _hoisted_3),
          _createElementVNode("p", null, _toDisplayString(_ctx.page) + "/" + _toDisplayString(_ctx.pageCount), 1),
          _createElementVNode("button", {
            disabled: _ctx.page >= _ctx.pageCount,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.page++))
          }, "+", 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true)
  ]))
}